import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { ICookieItem, ICookiesGroup } from '../../config';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
    selector: 'ts-cookie-consent-dialog',
    templateUrl: './cookie-consent-dialog.component.html',
    styleUrls: ['./cookie-consent-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CookieConsentDialogComponent implements OnInit {
  public items: ICookiesGroup[] = [];
  public customize: boolean;
  public customized: boolean;

  constructor(private cookiesService: CookieConsentService, private dialog: MatDialogRef<any>) {}

  ngOnInit(): void {
    this.items = this.cookiesService.cookieGroups;
    this.customize = JSON.parse(localStorage.getItem('experiments_customize_cookies') ?? 'false');
    this.customized = this.cookiesService.hasUserPreferences();
  }

  public toggleGroup(change: MatSlideToggleChange | boolean, group: ICookiesGroup) {
    const checked = change instanceof MatSlideToggleChange ? change.checked : change;
    group.allAccepted = group.needed ? true : checked;
    group.items = [...group.items.map((item) => ({ ...item, accepted: checked }))];
    this.customized = true;
  }

  public toggle(change: MatSlideToggleChange, group: ICookiesGroup, item: ICookieItem) {
    item.accepted = change.checked;
    group.allAccepted = group.needed ? true : group.items.every((item) => item.accepted);
    this.customized = true;
  }

  public rejectAll() {
    this.items.forEach((item) => this.toggleGroup(false, item));
    this.submit();
  }

  public acceptAll() {
    this.items.forEach((item) => this.toggleGroup(true, item));
    this.submit();
  }

  public submit() {
    for (const group of this.items) {
      for (const item of group.items) {
        localStorage.setItem(item._key, item.accepted.toString());
        switch (item.type) {
          case 'fullstory':
            this.cookiesService.setFullstoryEnabled(item.accepted);
            break;
        }
      }
    }
    this.cookiesService.saveUserPreferences();
    this.dialog.close();
  }
}
